exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-ee97ff64] {\n  pointer-events: none;\n  position: fixed;\n  right: 0;\n}\nsvg polygon[data-v-ee97ff64],\nsvg rect[data-v-ee97ff64] {\n  pointer-events: auto;\n}\n", ""]);

